<h2 mat-dialog-title>About this platform</h2>
<mat-dialog-content>
  <section>
    <img class="mood-logo" alt="MOOD" src="assets/images/logo_mood.png" />
    <div>
      <p>The platform was developed by the MOOD project.</p>
      <a href="https://doi.org/10.3030/874850" target="_blank" rel="noopener noreferrer">
        EU Horizon 2020 grant agreement No 874850
      </a>
    </div>
  </section>

  <section>
    <img class="geoai-logo" alt="GeoAI4EI" src="assets/images/logo_geoai4ei.svg" />
    <div>
      <p>Its functionality is being expanded by the GeoAI toolbox for Epidemic Intelligence project.</p>
      <a href="https://doi.org/10.3030/101287260" target="_blank" rel="noopener noreferrer">
        EU Horizon Europe grant agreement No 101287260
      </a>
    </div>
  </section>

  <img class="eu-funding-logo" alt="Co-funded by the European Union" src="assets/images/eu-co-funded.png" />
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
